import * as yup from 'yup';

import { translations } from 'locales/i18n';
import { euCountries } from 'utils/Countries';

export const companyValidationSchema = t =>
  yup.object().shape(
    {
      name: yup.string().required(),
      street: yup.string().required(),
      zip: yup.string().required(),
      city: yup.string().required(),
      country: yup.string().required(),
      phone: yup.string().nullable(),
      fax: yup.string().nullable(),
      homepage: yup.string().url().required(),
      email: yup.string().email().required(),
      description: yup.string().required(),
      courses: yup.array().of(yup.object()).min(1),
      mainContact: yup.object().shape({
        firstName: yup.string().required(),
        lastName: yup.string().required(),
        email: yup.string().email().required(),
        phone: yup.string().required(),
        position: yup.string().nullable()
      }),
      logo: yup.mixed(),
      sameInvoiceaddress: yup.boolean().required(),
      invoiceName: yup.string().when('sameInvoiceaddress', {
        is: false,
        then: yup.string().required(),
        otherwise: yup.string().nullable()
      }),
      invoiceStreet: yup.string().when('sameInvoiceaddress', {
        is: false,
        then: yup.string().required(),
        otherwise: yup.string().nullable()
      }),
      invoiceZip: yup.string().when('sameInvoiceaddress', {
        is: false,
        then: yup.string().required(),
        otherwise: yup.string().nullable()
      }),
      invoiceCity: yup.string().when('sameInvoiceaddress', {
        is: false,
        then: yup.string().required(),
        otherwise: yup.string().nullable()
      }),
      invoiceCountry: yup.string().when('sameInvoiceaddress', {
        is: false,
        then: yup.string().required(),
        otherwise: yup.string().nullable()
      }),
      invoiceEmail: yup.string().email(t(translations.validation.email())).required().nullable(),
      taxId: yup
        .string()
        .when(['country', 'taxNumber', 'taxId'], {
          is: (country, taxNumber, taxId) => country === 'Germany' && !taxNumber && !taxId,
          then: yup
            .string()
            .max(32, t(translations.validation.max(), { max: 32 }))
            .required(t(translations.validation.taxIdOrTaxNumber()))
            .matches(/^[a-zA-Z0-9]{8,15}$/, t(translations.validation.taxIdFormat()))
            .nullable(),
          otherwise: yup.string().max(32, t(translations.validation.max())).nullable()
        })
        .when('country', {
          is: country => euCountries.includes(country) && country !== 'Germany',
          then: yup
            .string()
            .max(32, t(translations.validation.max(), { max: 32 }))
            .required(t(translations.validation.taxIdEuCountry()))
            .matches(/^[a-zA-Z0-9]{8,15}$/, t(translations.validation.taxIdFormat()))
            .nullable(),
          otherwise: yup.string().max(32, t(translations.validation.max())).nullable()
        }),
      taxNumber: yup.string().when(['country', 'taxId', 'taxNumber'], {
        is: (country, taxId, taxNumber) => country === 'Germany' && !taxNumber && !taxId,
        then: yup
          .string()
          .max(32, t(translations.validation.max(), { max: 32 }))
          .matches(new RegExp('^[0-9]{2,3}/[0-9]{3,4}/[0-9]{3,4}[0-9]$'), {
            message: t(translations.validation.taxNumberFormat()),
            excludeEmptyString: true
          })
          .required(t(translations.validation.taxIdOrTaxNumber()))
          .nullable(),
        otherwise: yup
          .string()
          .max(32, t(translations.validation.max(), { max: 32 }))
          .matches(new RegExp('^[0-9]{2,3}/[0-9]{3,4}/[0-9]{3,4}[0-9]$'), {
            message: t(translations.validation.taxNumberFormat()),
            excludeEmptyString: true
          })
          .nullable()
      })
    },
    [
      ['taxId', 'taxId'],
      ['taxId', 'taxNumber'],
      ['taxNumber', 'taxId'],
      ['taxNumber', 'taxNumber']
    ]
  );
